import React from "react";
import {
  Container,
  Heading,
  BasicText,
  Highlighter,
  Heading3,
  CodeOuter,
  CodeView,
  LongImage
} from "../styles";
import coverImage from "../assets/coverpage3.png";
import styled from "styled-components";

const Item = styled.li`
  margin: 13px 0px 13px 0px;
`;

class Text extends React.Component {
  render() {
    return (
      <Container>
        <Heading>Text</Heading>
        <ul>
          <Item>
            <BasicText>
              The default Text color on Android is
              <Highlighter>gray</Highlighter> and
              <Highlighter>black</Highlighter> on IOS. The normalized default
              color of the text is black <Highlighter>#000000</Highlighter>
            </BasicText>
          </Item>
          <Item>
            <BasicText>
              The default font on Android is explicitly set to Roboto. This
              fixes an issue which cuts off text on Oppo and OnePlus phones.
            </BasicText>
          </Item>
        </ul>

        <LongImage>
          <img style={{ paddingTop: 15, marginBottom: 20 }} src={coverImage} />
        </LongImage>
        <Heading3>Usage</Heading3>
        <BasicText>
          You just need to import<Highlighter>Text</Highlighter>
          from <b>react-native-normalized</b> instead of <b>react-native!</b>
        </BasicText>
        <CodeOuter>
          <CodeView className="javascript">
            {
              "import React from 'react';\r\nimport { View } from 'react-native';\r\nimport { Text } from 'react-native-normalized';\r\n\r\nclass Example extends React.Component {\r\n  render(){ \r\n    return(\r\n      <View style={{ flex:1}}>\r\n       <Text> I am Normalized </Text>\r\n     </View>\r\n    )\r\n  }\r\n}"
            }
          </CodeView>
        </CodeOuter>
      </Container>
    );
  }
}

export default Text;
